export enum SHARED_LIBRARY_ASSET_KEYS {
  CALENDAR_ICON = 'CALENDAR_ICON',
  ATTENTION_ICON = 'ATTENTION_ICON',
  LEFT_ARROW_DISABLED_ICON = 'LEFT_ARROW_DISABLED_ICON',
  LEFT_ARROW_ICON = 'LEFT_ARROW_ICON',
  RIGHT_ARROW_ICON = 'RIGHT_ARROW_ICON',
  RIGHT_ARROW_DISABLED_ICON = 'RIGHT_ARROW_DISABLED_ICON',
  CROSS_ICON = 'CROSS_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  EXIT_WARNING = 'EXIT_WARNING',
  FAILURE_ICON = 'FAILURE_ICON',
  TICK_BUTTON = 'TICK_BUTTON',
}

export type SharedLibraryAssets = Record<SHARED_LIBRARY_ASSET_KEYS, unknown>;
